import { CgNotes } from "react-icons/cg";

export const isNotesMessage = (text) => {
  if (!text || typeof text !== "string") return false;
  return text.includes("📋 Catatan") && text.includes("Diagnosa:");
};

const parseGreeting = (text) => {
  const diagMatch = text.match(/Diagnosa:\s*([^•\n]+)/);
  const diagnosa = diagMatch ? diagMatch[1].trim() : "";
  const saranMatches = text.match(/•\s*([^•\n]+)/g) || [];
  const saranList = saranMatches
    .map((s) => s.replace(/^•\s*/, "").trim())
    .filter(Boolean);

  return { diagnosa, saranList };
};

const NotesMessageBubble = ({ text, isFromMe, time }) => {
  const { diagnosa, saranList } = parseGreeting(text);

  return (
    <div
      className={`max-w-[70%] py-2 px-2.5 shadow-sm break-words text-md -mb-2 ${
        isFromMe
          ? "bg-secondary text-white rounded-tl-xl rounded-bl-xl rounded-tr-xl"
          : "bg-white text-slate-700 rounded-tr-xl rounded-br-xl rounded-bl-xl"
      }`}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="text-base">
          <CgNotes size={16} className="text-blue-500" />
        </span>
        <span className="font-medium text-base">Catatan</span>
      </div>

      {diagnosa && (
        <div className="mb-1">
          <p className="font-medium">Diagnosa: {diagnosa}</p>
        </div>
      )}

      {saranList.length > 0 && (
        <ul className="list-disc ml-5 space-y-1">
          {saranList.map((saran, i) => (
            <li key={i} className="leading-tight">
              {saran}
            </li>
          ))}
        </ul>
      )}

      <div className="text-right mt-1">
        <span className="text-sm opacity-70">{time}</span>
      </div>
    </div>
  );
};

export default NotesMessageBubble;
